export default __webpack_public_path__ + "static/media/hirist_logo.7682387f.webp";